import React, { useContext, useState, useEffect } from "react";
import "./App.css";
import Logo from "./11-Fit-Logo-TG.svg";
import MenuButton from "./images/menu-button.svg";
import ScrollToSection from "./ScrollToSection";
import { useNavigate, useLocation } from "react-router-dom";
import IconCart from './images/icon-cart-TG.svg'; // #added 19/7/25 TG
import { AppContext } from "./ContextVars";
import translations from './translations';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate(); // #added 29/3/25 TG
  const location = useLocation(); // #added 29/3/25 TG
  const {cart, testMode, siteVersion, language, setLanguage} = useContext(AppContext);
  const [cartQuantity, setCartQuantity] = useState(0); // #added 19/7/25 TG
  
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleScroll = (sectionId) => { // #added 28/3/25 TG
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    setMenuOpen(false);
  };

  const handleNavigation = (section) => {
    if (location.pathname !== "/") {
      navigate("/"); // Navigate to Home first
      setTimeout(() => handleScroll(section), 300); // Delay scroll to ensure Home loads
    } else {
      handleScroll(section); // If already on Home, just scroll
    }
  };

  useEffect(() => {
    if (cart?.length > 0) {
      setCartQuantity(cart.length ?? 0);
    }
  }, [cart]);

  const t = (key) => translations.Navbar[key]?.[language] || key;

  const toggleLanguage = () => {
    setLanguage(lang => lang === 'es' ? 'en' : 'es');
  };

  return (
    <header className={`navbar ${menuOpen ? "open" : ""}`}>
      <div className="navbar__logo" onClick={() => {navigate("/"); setMenuOpen(false);}} style={{cursor: 'pointer'}}>
        <img src={Logo} alt="Logo" className="logo-img" />
        <h1>
          <span className="color-1">eleven</span>
          <span className="fit">.fit</span>
          {testMode && <span className="margin-left-10 color-1 font-weight-300 font-size-20">v.{siteVersion}</span>}
        </h1>
      </div>
      <nav className="navbar__links">

        <button onClick={() => {navigate("/")}} className="nav-button">{t('home')}</button>
        <button onClick={() => navigate("/workouts")} className="nav-button">{t('workouts')}</button>
        <button onClick={() => navigate("/program")} className="nav-button">{t('program')}</button>{/* probablemente remover y poner todo dentro de workouts*/}
        <button onClick={() => window.location.href = "https://eleven.fit/timer/workouts"} className="nav-button">{t('app')}</button>
        {/* #deleted temporalmente, todavía no hay productos en la tienda 24/8/26 TG
        <button onClick={() => {navigate("/store")}} className="nav-button">{t('store')}</button>
        */}
        <button onClick={() => {navigate("/about"); setMenuOpen(false);}} className="nav-button">{t('whoAmI')}</button>
        <button onClick={() => {navigate("/contact")}} className="nav-button">{t('contact')}</button>
        <button onClick={toggleLanguage} className="nav-button" style={{fontWeight: 700, fontSize: '14px'}}>{language === 'es' ? 'EN' : 'ES'}</button>
        {cartQuantity > 0 && <button onClick={() => {navigate("/cart")}} className="nav-button"><img src={IconCart} alt='' className="cart-button" />({cartQuantity})</button>}

        


        {/*<a href="#home">Home</a>
        <a href="#program">Workouts</a>
        <a href="#app">App</a>
        <a href="#fit-for-life">Store</a>
        <a href="#fit-for-life">Fit For Life</a>
        <a href="#who-am-i" className="hide-medium">
          Who Am I?
        </a>
        <a href="#contact" className="hide-medium">
          Contact
        </a>*/}
      </nav>
      {/* Hamburger menu button */}
      <div
        // href="#menu"
        className="navbar__menu-toggle"
        onClick={(e) => {
          e.preventDefault();
          toggleMenu();
        }}
      >
        <img src={MenuButton} alt="Menu" />
      </div>
      {/* Dropdown menu */}
      {menuOpen && (
        <nav className="navbar__menu">
          <button onClick={() => {navigate("/"); setMenuOpen(false);}} className="drop-button">
            {t('home')}
          </button>
          <button onClick={() => {navigate("/workouts"); setMenuOpen(false);}} className="drop-button">
            {t('workouts')}
          </button>
          <button onClick={() => {navigate("/program"); setMenuOpen(false);}} className="drop-button">
            {t('program')}
          </button>
          <button onClick={() => window.location.href = "https://eleven.fit/timer/workouts"} className="drop-button">
            {t('app')}
          </button>
          {/* #deleted temporalmente, todavía no hay productos en la tienda 24/8/26 TG
          <button onClick={() => handleNavigation("/store")} className="drop-button">
            {t('store')}
          </button>
          */}
          <button onClick={() => {navigate("/about"); setMenuOpen(false);}} className="drop-button">
              {t('whoAmI')}
          </button>
          <button onClick={() => {navigate("/contact"); setMenuOpen(false);}} className="drop-button">
              {t('contact')}
          </button>
          <button onClick={() => {toggleLanguage(); setMenuOpen(false);}} className="drop-button" style={{fontWeight: 700}}>
            {language === 'es' ? 'EN 🇺🇸' : 'ES 🇪🇸'}
          </button>
          {cartQuantity > 0 && <button onClick={() => {navigate("/cart"); setMenuOpen(false);}} className="drop-button cart-align">
              <img src={IconCart} alt='' className="cart-button" />
              ({cartQuantity})
          </button>}

              
          {/*<a href="#home" onClick={() => setMenuOpen(false)}>
            Home
          </a>
          <a href="#program" onClick={() => setMenuOpen(false)}>
            Workouts
          </a>
          <a href="#app" onClick={() => setMenuOpen(false)}>
            App
          </a>
          <a href="#store" onClick={() => setMenuOpen(false)}>
            Store
          </a>
          <a href="#fit-for-life" onClick={() => setMenuOpen(false)}>
            Fit For Life
          </a>
          <a href="#who-am-i" onClick={() => setMenuOpen(false)}>
            Who Am I?
          </a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>
            Contact
          </a>*/}
        </nav>
      )}
    </header>
  );
};

export default Navbar;
